import { Injectable } from '@angular/core';
import { PinType } from '@store/weathermap.store';
import { MAP_ZOOM_CACHE_KEY, PIN_TYPE_CACHE_KEY, STATION_ID_CACHE_KEY } from 'src/app/weathermap.const';

enum SharePinType {
  TEMPERATURE = 'temp',
  RAIN = 'rain',
  WIND = 'wind',
}

const SharePinTypeMap: Record<SharePinType, PinType> = {
  [SharePinType.TEMPERATURE]: PinType.TEMPERATURE,
  [SharePinType.RAIN]: PinType.RAIN,
  [SharePinType.WIND]: PinType.WIND,
};

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  loadFromUrl(): void {
    const params = new URLSearchParams(location.search);

    if (params.get('zoom')) {
      const zoom = params.get('zoom');
      if (!isNaN(Number(zoom))) {
        localStorage.setItem(MAP_ZOOM_CACHE_KEY, zoom);
      }
    }

    if (params.get('type')) {
      const type = params.get('type');
      if (SharePinTypeMap[type]) {
        localStorage.setItem(PIN_TYPE_CACHE_KEY, SharePinTypeMap[type]);
      }
    }

    if (params.get('stationid')) {
      const stationId = params.get('stationid');
      if (/(([0-9]|[a-fA-f]){2}:){5}([0-9]|[a-fA-f]){2}/.test(stationId)) {
        localStorage.setItem(STATION_ID_CACHE_KEY, stationId);
      }
    }
  }
}
